'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var stripTags = _interopDefault(require('striptags'));
var truncate = _interopDefault(require('lodash.truncate'));

/**
 * Copyright © 2019 Eric Lu. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */
var defaultOptions = {
  moreRegExp: /\s*<!--\s*more\s*-->/i,
  stripTags: true,
  pruneLength: 140,
  pruneString: '…',
  pruneSeparator: ' '
};
/**
 * Retrieve excerpt from html by extracting contents until a 'more' tag
 * @param  {string} html   html
 * @param  {RegExp} regExp 'more' tag regexp
 * @return {string}         excerpt string or null
 */

function getExcerptByMoreTag(html, regExp) {
  var match = html.search(regExp);

  if (match === -1) {
    return null;
  }

  var excerpt = html.slice(0, Buffer.byteLength(html.slice(0, match)));
  return excerpt;
}
/**
 * Retrieve excerpt from html by extracting the first p's contents
 * @param  {string} html html
 * @return {string}       excerpt string
 */


function getExcerptByFirstParagraph(html) {
  var regExpOpen = /<p>/i;
  var regExpClose = /<[ ]*\/[ ]*p>/i;
  var matchOpen = html.search(regExpOpen);

  if (matchOpen === -1) {
    return html;
  }

  var rest = html.substring(matchOpen + 3);
  var matchClose = rest.search(regExpClose);
  var excerpt = rest.slice(0, matchClose);
  return excerpt;
}
/**
 * @param {string} excerpt Already extracted excerpt
 * @param {Object} options stripping options
 * @param {number} [options.pruneLength]
 * @param {string} [options.pruneSeparator]
 * @param {string} [options.pruneString]
 * @return {string} The stripped and pruned excerpt
 */


function stripTagsFromExcerpt(excerpt, options) {
  var str = stripTags(excerpt);
  str = str.replace(/^\s+|\s+$|\s+(?=\s)/g, '');

  if (options.pruneLength > 0) {
    str = truncate(str, {
      length: options.pruneLength,
      omission: options.pruneString,
      separator: options.pruneSeparator
    });
  }

  return str;
}
/**
 * Extracts the raw excerpt (without stripped tags) from the html
 * @param {string} html Html string to look for the excerpt
 * @param {RegExp} [moreRegExp=/\s*<!--\s*more\s*-->/i]
 *  RegExp used to look for the end of the excerpt
 * @return If found, the excerpt from the more tag, else the excerpt contained in the first <p></p>
 */


function getRawExcerpt(html, moreRegExp) {
  return getExcerptByMoreTag(html, moreRegExp) || getExcerptByFirstParagraph(html);
}

function htmlExcerpt(html) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var opts = Object.assign({}, defaultOptions, options);
  var rawExcerpt = getRawExcerpt(html, opts.moreRegExp);

  if (opts.stripTags === false) {
    return rawExcerpt;
  }

  return stripTagsFromExcerpt(rawExcerpt, opts);
}

/**
 * Copyright © 2019 Eric Lu. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

module.exports = htmlExcerpt;
